import * as tslib_1 from "tslib";
import { MatDialog } from '@angular/material';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { FilterService } from './filter/filter.service';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { ExportDialogComponent } from '@core/components/export-dialog/export-dialog.component';
import { ExportDialogTypeEnum } from '@core/components/export-dialog/export-dialog.types';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var DashboardFormsComponent = /** @class */ (function () {
    function DashboardFormsComponent(matDialog, filterService, authenticationService, fuseTranslationLoaderService) {
        this.matDialog = matDialog;
        this.filterService = filterService;
        this.authenticationService = authenticationService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.hasCreateExportPermission = this.authenticationService.hasPermission('exports-create');
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    DashboardFormsComponent.prototype.exportFormAnswers = function () {
        this.matDialog.open(ExportDialogComponent, {
            panelClass: 'export-dialog',
            autoFocus: false,
            data: {
                type: ExportDialogTypeEnum.formAnswers,
                where: tslib_1.__assign({}, this.filterService.toDetailQuery())
            }
        });
    };
    return DashboardFormsComponent;
}());
export { DashboardFormsComponent };
